module.exports = __webpack_public_path__ + "img/spark_basket_04.8525b5a7.png";